var embeddedVideoTemplate = require('./modal-video-promo.handlebars');

$(function () {

    $.fn.EmbeddedVideoModal = function (action) {

        return this.each(function () {
            var $toggle = $(this),
                modalId = $toggle.attr('id') + "-modal",
                $modal = $("#" + modalId),
                settings = {
                    modalId: modalId,
                    modalTitle: $toggle.data("video-title"),
                    videoUrl: $toggle.data("video-url"),
                    videoType: $toggle.data("video-type")
                };

            if (typeof action === 'undefined') {
                //Initialize
                createEmbeddedVideoModal(settings);
            }

            if (action === 'open') {
                //Initialize if doesn't exist
                if (!$modal.length) createEmbeddedVideoModal(settings);

                //open
                openEmbeddedVideoModal($modal);
            }

            if (action === 'close') {
                //close
                closeEmbeddedVideoModal($modal);
            }

            //Init button click event
            $toggle.on('click', function () {
                $(this).EmbeddedVideoModal('open');
            });
        });

        function createEmbeddedVideoModal(data) {
            var html = embeddedVideoTemplate({ data: data });
            $('body').append(html);
        }

        function closeEmbeddedVideoModal($modal) {
            $modal.modal('hide');
        }

        function openEmbeddedVideoModal($modal) {
            $modal.modal('show');
        }
    };

    //Default Initialize
    $('[data-toggle="modal-video"]').EmbeddedVideoModal();
});

/*---Below is to reset the iframe URL in the modal popup---*/
$(document).ready(function() {
    $('*').on('click', function(e) {
        if($(e.target).prop('class')!='' && !$(e.target).hasClass('modal-content') && !$(e.target).hasClass('modal-header') && !$(e.target).hasClass('modal-body'))
        {              
          var $this = $('#myModal').find('iframe');
          let tempSrc = $this.attr('src');
          $this.attr('src', "");
          //console.log('video URL: '+tempSrc);
          $this.attr('src', tempSrc);
        }
        else{
           // console.log('current class name: '+$(e.target).prop('class'));
        }
    });
});





// WEBPACK FOOTER //
// ./shared/components/video-promo/video-promo.js